import Button from "components/atoms/buttons/Button";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import Loading from "components/atoms/Loading";
import ClaimCodeWithInstructionsModal from "./ClaimCodeWithInstructionsModal";

type Props = {
  disabled?: boolean;
  onModalClose: () => void;
  handlePublishuttonClick: () => void;
  magnetDetails: {
    brand_name: string;
    name: string;
    image_url: string;
  };
};

function BottomBarButtons({
  handleCancelButtonClick,
  handlePublishuttonClick,
  disabled = false,
}: {
  handleCancelButtonClick: () => void;
  handlePublishuttonClick: () => void;
  disabled?: boolean;
}) {
  return (
    <>
      <div className="w-40 2xl:w-60">
        <Button
          disabled={disabled}
          variant="whiteOutline"
          text="CANCEL"
          additionalClasses="xl:py-2 xl:text-xxs 2xl:text-sm 2xl:py-4 w-full"
          onClick={handleCancelButtonClick}
        />
      </div>
      <div className="w-40 2xl:w-60">
        <Button
          disabled={disabled}
          text="PUBLISH"
          variant="magnetiqSolid"
          additionalClasses="xl:py-2 xl:text-xxs 2xl:text-sm 2xl:py-4 w-full"
          onClick={handlePublishuttonClick}
        />
      </div>
    </>
  );
}

function ClaimModalContainer({ onModalClose, handlePublishuttonClick, magnetDetails, disabled = false }: Props) {
  const { getValues } = useFormContext();
  const claimData = getValues();

  const getMerchDropImage = useMemo(
    () => (claimData.thumbnail ? URL.createObjectURL(claimData.thumbnail) : claimData.thumbnail_url),
    [claimData.thumbnail, claimData.thumbnail_url],
  );
  if (!claimData) return <Loading />;

  return (
    <ClaimCodeWithInstructionsModal
      disabled={disabled}
      magnetImageUrl={magnetDetails.image_url}
      brandName={magnetDetails.brand_name}
      magnetName={magnetDetails.name}
      mementoName={claimData.name}
      mementoDescription={claimData.description}
      mementoImage={getMerchDropImage}
      mementoInstructions={claimData.claim_instructions}
      onClose={onModalClose}
      getActionButtons={
        <BottomBarButtons
          disabled={disabled}
          handleCancelButtonClick={onModalClose}
          handlePublishuttonClick={handlePublishuttonClick}
        />
      }
    />
  );
}
export default ClaimModalContainer;
